const MILLISECONDS_PER_SECOND = 1000;
const NO_TIME_LIMIT = 0;

function hasTimeLimit(timeLimitInSeconds) {
  return Number(timeLimitInSeconds) > NO_TIME_LIMIT;
}

export function resolveDraftResume(tempResponse, now) {
  const { response, savedAt } = tempResponse;
  const timeLimitInSeconds = response && response.timeLimit;
  if (!hasTimeLimit(timeLimitInSeconds)) {
    return { canResume: true, timeLimit: NO_TIME_LIMIT };
  }
  const timeLimitInMilliseconds = timeLimitInSeconds * MILLISECONDS_PER_SECOND;
  const elapsedTime = now - savedAt;
  if (elapsedTime >= timeLimitInMilliseconds) {
    return { canResume: false, timeLimit: NO_TIME_LIMIT };
  }
  return {
    canResume: true,
    timeLimit: (timeLimitInMilliseconds - elapsedTime) / MILLISECONDS_PER_SECOND
  };
}
